import { render, staticRenderFns } from "./Tfa.vue?vue&type=template&id=7e0f76ff&scoped=true&"
import script from "./Tfa.vue?vue&type=script&lang=ts&"
export * from "./Tfa.vue?vue&type=script&lang=ts&"
import style0 from "./Tfa.vue?vue&type=style&index=0&id=7e0f76ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0f76ff",
  null
  
)

export default component.exports